import React, { useEffect, useState } from 'react';
import List from '../../components/GuarantyClaims/projectWiseClaimCount';
import SearchBar from '../../components/GuarantyClaims/projectWiseClaimCount/searchFilter';
import Layout from '../../components/common/pageLayout';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v3_project_wise_claim_count } from '../../actions/v3/guaranteeClaims';
import { replacePageState } from '../../utils';

const ProjectWiseDocumentCount = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);
    const [payload, setPayload] = useState('');

    useEffect(() => {
        fetchProjects();
    }, [currentPage, limit, payload]);

    const fetchProjects = () => {
        v3_project_wise_claim_count(currentPage, limit, payload).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.projectGuarantyClaimCount.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error || "Failed to fetch project list");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Something went wrong");
        });
    };


    return (
        <Layout title={'Guarantee Claims'}>
            <SearchBar
                onSearch={(newPayload) => { setPayload(newPayload) }}
                onReset={() => { setPayload('') }}
            />
            <List
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />
        </Layout>
    );
};

export default ProjectWiseDocumentCount;
